import React from "react";
import food from "../assets/images/order/food.png";
import GroupOrderedItem from "../components/GroupOrderedItem";
import man from "../assets/images/group/man.png";
import rightarrow from "../assets/images/arrow-right.png";
import share from "../assets/images/order/share.png";

const GroupOrderGuest = () => {
  const items = [
    {
      image: food,
      itemName: "Garlic Noodles",
      itemPrice: 100,
      discountedPrice: 80,
      quantity: "5 Qty",
      addedBy: "Rohan",
    },
    {
      image: food,
      itemName: "Garlic Noodles",
      itemPrice: 100,
      discountedPrice: 80,
      quantity: "5 Qty",
      addedBy: "Ronit",
    },
    {
      image: food,
      itemName: "Garlic Noodles",
      itemPrice: 100,
      discountedPrice: 80,
      quantity: "5 Qty",
      addedBy: "Aman",
    },
    {
      image: food,
      itemName: "Garlic Noodles",
      itemPrice: 100,
      discountedPrice: 80,
      quantity: "5 Qty",
      addedBy: "Yash",
    },
    {
      image: food,
      itemName: "Garlic Noodles",
      itemPrice: 100,
      discountedPrice: 80,
      quantity: "5 Qty",
      addedBy: "Rittik",
    },
    {
      image: food,
      itemName: "Garlic Noodles",
      itemPrice: 100,
      discountedPrice: 80,
      quantity: "5 Qty",
      addedBy: "Rokey",
    },
    {
      image: food,
      itemName: "Garlic Noodles",
      itemPrice: 100,
      discountedPrice: 80,
      quantity: "5 Qty",
      addedBy: "Krish",
    },
  ];

  return (
    <div className="flex border-2 bg-[#FFFFFF]">
      <div className="w-[35%] border-r py-6">
        <div className="px-8 ">
          <h6 className="text-[#6A6A6A] text-left font-Urbanist text-[16px] font-medium leading-[20px] ml-[60px]">
            Group Order
          </h6>

          <div className="mt-4 min-w-[418px] w-full flex flex-col justify-center items-center gap-[25px]">
            <div className="flex justify-between items-center w-[80%] mx-auto">
              <div className="flex">
                <h6 className="text-[#050505] font-Urbanist text-[22px] font-semibold leading-[140%] ">
                  Aman Bansal’s Group
                </h6>
                <span className="bg-[#7604A5] px-[12px] pt-[8px] rounded-[10px] text-white text-[15px] font-semibold leading-[18px] ml-[8px]">
                  14 mins left
                </span>
              </div>
              <div className="flex items-center bg-[#F5F5F5] px-[12px] py-[10px] cursor-pointer rounded-[10px]">
                <img src={share} alt="share" className="h-[24px] w-[24px]" />
                <span className="ml-[8px]">Share</span>
              </div>
            </div>

            {/* address */}
            <div className="border-[#E3E3E3] rounded-[16px] border-2 p-[12px] w-[80%] mx-auto">
              <h6 className="text-[#050505] font-Urbanist text-[16px] font-semibold leading-[140%] border-b-2 pb-[12px]">
                Delivery at
              </h6>
              <h6 className="text-[#050505] font-Urbanist text-[14px] font-medium leading-[160%] pt-[12px]">
                F 43, Block C, Sector 62, Noida, Uttar Pradesh
              </h6>
            </div>

            <div className="h-[1px] w-[80%] bg-[#E3E3E3] mx-auto"></div>

            {/* guest order details*/}
            <div className="border rounded-[16px] p-[12px] w-[80%] mx-auto">
              <div className="flex items-center gap-[8px] pb-[12px] border-b-2 border-[#E3E3E3]">
                <div>
                  <img
                    src={man}
                    alt="man"
                    className="h-[36px] w-[36px] rounded-full"
                  />
                </div>
                <div>
                  <p className="text-[#050505] font-Urbanist text-[16px] font-semibold leading-[140%]">
                    Abhishek Kumar (Host)
                  </p>
                  <p className="text-[#6A6A6A] font-Urbanist text-[14px] font-medium leading-[15px]">
                    2 Items added
                  </p>
                </div>
              </div>
              {items.slice(0, 2).map((item, index) => (
                <GroupOrderedItem
                  key={index}
                  image={item.image}
                  itemName={item.itemName}
                  itemPrice={item.itemPrice}
                  discountedPrice={item.discountedPrice}
                  quantity={item.quantity}
                  addedBy={item.addedBy}
                />
              ))}
            </div>

            {/* guest order details*/}
            <div className="border rounded-[16px] p-[12px] w-[80%] mx-auto">
              <div className="flex items-center gap-[8px] pb-[12px] border-b-2 border-[#E3E3E3]">
                <div>
                  <img
                    src={man}
                    alt="man"
                    className="h-[36px] w-[36px] rounded-full"
                  />
                </div>
                <div>
                  <p className="text-[#050505] font-Urbanist text-[16px] font-semibold leading-[140%]">
                    Abhishek Kumar (Host)
                  </p>
                  <p className="text-[#6A6A6A] font-Urbanist text-[14px] font-medium leading-[15px]">
                    2 Items added
                  </p>
                </div>
              </div>
              {items.slice(0, 2).map((item, index) => (
                <GroupOrderedItem
                  key={index}
                  image={item.image}
                  itemName={item.itemName}
                  itemPrice={item.itemPrice}
                  discountedPrice={item.discountedPrice}
                  quantity={item.quantity}
                  addedBy={item.addedBy}
                />
              ))}
            </div>

            <button
              className="w-[80%] mx-auto flex items-center justify-between py-4 px-6 bg-[#FF8A00] rounded-[150px] cursor-pointer hover:bg-[#5f0289] transition-colors"
              // onClick={() => {
              //   navigate("/group-order");
              // }}
            >
              <span className="w-full text-white text-center font-Urbanist text-[20px] font-semibold leading-[140%]">
                Create Your Group
                <img
                  src={rightarrow}
                  alt="Right Arrow"
                  className="inline-block ml-2 h-[24px] w-[24px]"
                />
              </span>
            </button>
          </div>
        </div>
      </div>

      <div className="w-[65%] border-l relative">
        {/* Tabs */}
        <div className=" mt-[15px]">
          <div className="flex justify-between items-center mx-[20px] px-[32px]">
            <span className="text-[#7604A5] text-start font-Urbanist text-[20px] font-medium leading-[120%]">
              {" "}
              + Add Items
            </span>
          </div>
        </div>

        {/* items section */}
        <div className="px-12">
          {items.map((item, index) => (
            <GroupOrderedItem
              key={index}
              image={item.image}
              itemName={item.itemName}
              itemPrice={item.itemPrice}
              discountedPrice={item.discountedPrice}
              quantity={item.quantity}
              addedBy={item.addedBy}
              //   onCountChange={(count) => handleItemCountChange(index, count)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default GroupOrderGuest;
